import styled, { css } from 'styled-components'

export const StyledWrapper = styled.div`
  width: 600px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px 70px;
`

const commonStyles = css`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`
export const StyledTitle = styled.span`
  ${commonStyles}
  text-align: center;
`

export const StyledSelectTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding-bottom: 16px;
  border-bottom: 1px solid #c2c8d1;
`

export const StyledTypeWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  cursor: pointer;

  & > span {
    min-width: 20px;
  }

  ${props =>
    props.isSelected &&
    css`
      & > span > span {
        visibility: visible;
      }
    `}
`

export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const StyledRadioTitle = styled.span`
  ${commonStyles}
`

export const StyledWarning = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: #de2f4c;
`

export const StyledMetricInfo = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #798498;
`

export const StyledButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  padding-bottom: 40px;
`
